var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCustomerIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 19,
    viewBox: "0 0 22 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6 4.2001C14.6 6.18832 12.9882 7.8001 11 7.8001C9.01177 7.8001 7.4 6.18832 7.4 4.2001C7.4 2.21187 9.01177 0.600098 11 0.600098C12.9882 0.600098 14.6 2.21187 14.6 4.2001Z",
    fill: "#6B7280"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6 6.6001C20.6 7.92558 19.5255 9.0001 18.2 9.0001C16.8745 9.0001 15.8 7.92558 15.8 6.6001C15.8 5.27461 16.8745 4.2001 18.2 4.2001C19.5255 4.2001 20.6 5.27461 20.6 6.6001Z",
    fill: "#6B7280"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8 15.0001C15.8 12.3491 13.651 10.2001 11 10.2001C8.34903 10.2001 6.2 12.3491 6.2 15.0001V18.6001H15.8V15.0001Z",
    fill: "#6B7280"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.2 6.6001C6.2 7.92558 5.12548 9.0001 3.8 9.0001C2.47451 9.0001 1.4 7.92558 1.4 6.6001C1.4 5.27461 2.47451 4.2001 3.8 4.2001C5.12548 4.2001 6.2 5.27461 6.2 6.6001Z",
    fill: "#6B7280"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2 18.6001V15.0001C18.2 13.7351 17.8738 12.5463 17.3009 11.5133C17.5883 11.4394 17.8895 11.4001 18.2 11.4001C20.1882 11.4001 21.8 13.0119 21.8 15.0001V18.6001H18.2Z",
    fill: "#6B7280"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.69911 11.5133C4.12621 12.5463 3.8 13.7351 3.8 15.0001V18.6001H0.199997V15.0001C0.199997 13.0119 1.81177 11.4001 3.8 11.4001C4.11045 11.4001 4.41172 11.4394 4.69911 11.5133Z",
    fill: "#6B7280"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerIcon);
export default __webpack_public_path__ + "static/media/customerIcon.e4ce8367adf2d221d7fa8328524c1357.svg";
export { ForwardRef as ReactComponent };